// import {hackFixDSTExcelDates} from '../../core-utilities/redux-observable-list-exports/utils';
import {ReduxListExports} from '../../core-utilities/redux-observable-list-exports';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {FormExportReqs} from '../components/FormExportReqs';
import {getFormExportReqs} from '../reducers/state';
import {FORM_COLLECTION} from '../domain/config';
import {FORM_EXPORT_REQ_PREFIX} from './state';
import {logger} from './logger';


const dateTimeFormat = encodeURIComponent("M/d/yyyy H:mm");
const dateOnlyFormat = encodeURIComponent("M/d/yyyy");
const timeOnlyFormat = encodeURIComponent("H:mm");

/** @type {ReduxListExports} */
export const formResponseRequirementExports = new ReduxListExports({
  ...BASE_REDUX_LIST_OPTIONS,
  prefix: FORM_EXPORT_REQ_PREFIX,
  hasParentId: true,
  reportPath: parentId => `${FORM_COLLECTION}/${parentId}/requirement-responses`,
  useFilter: false,
  useFilterOptions: false,
  useSortOptions: false,
  modalComponent: FormExportReqs,
  // TODO: sanitize file name
  getFileName: request => `${request.formTitle} Form Requirement Data`,
  buildRequest,
  getParams,
  // TODO: may be fixable from server side?
  // modifyResponse: hackFixDSTExcelDates(dateHeaders),
  getReportState: getFormExportReqs,
  exportConfig: {
    useListStateFilter: false,
    getDefaultFilterData: () => {},
  },
  logger,
});

function buildRequest(exportState) {
  return {
    parentId: exportState.parentId,
    formTitle: exportState.formTitle,
  };
}

function getParams() {
  return `dateTimeFormat=${dateTimeFormat}&dateOnlyFormat=${dateOnlyFormat}&timeOnlyFormat=${timeOnlyFormat}`;
}



// WEBPACK FOOTER //
// ./src/js/forms/redux/formResponseRequirementExports.js